/**
 * @file orderModification.service.ts
 * @description Manages order line item cancellations and reason audits.
 */

import { supabase } from '../../../config/supabase.config';

export const cancelOrderItem = async (
  orderItemId: string,
  reason: string
): Promise<void> => {
  const { error } = await supabase.rpc('cancel_order_item_with_reason', {
    p_order_item_id: orderItemId,
    p_reason: reason,
  });

  if (error) {
    console.error('[orderModification.service] Cancel error:', error);
    throw error;
  }
};
